import styled from 'styled-components'

export const StyledErrorText = styled.div`
`
